import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/hcl_thumb.png"

export function Index() {
  return (
    <Layout
      title="HCL Tech Global Event Photo Sharing – Privacy & Compliance with Premagic"
      description="Learn how HCL Tech uses Premagic at 10+ global events for secure, privacy-compliant photo sharing while upholding enterprise data security standards."
      metaImage={ThumbnailImage}
      keywords={[
        "HCL Tech case study, enterprise event privacy, corporate photo sharing, global IT events, privacy-compliant photos, enterprise event technology, HCL corporate events, B2B event solutions, secure photo distribution, enterprise photo management, corporate event compliance, IT company events, global enterprise events, business event privacy, corporate photo security, data security compliance",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "HCL Tech", url: "/case-study/hcl/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "HCL Tech Global Event Photo Sharing - Privacy & Compliance with Premagic",
            "description": "Learn how HCL Tech uses Premagic at 10+ global events for secure, privacy-compliant photo sharing while upholding enterprise data security standards.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.HCL} />
    </Layout>
  )
}

export default Index
